import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";

const ContentImageModel = ({ 
  isOpen,
  toggle,
  data,
   
  }) => {
  return (
    <Modal
      isOpen={isOpen}
      size="md"
      toggle={toggle}
      className="modal-dialog-centered"
    >
      <ModalBody className="p-2">
      <div><img class="rounded-5" src={data?.content_img}  alt="content_image" /></div>
      </ModalBody>
    </Modal>
  );
};

ContentImageModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

ContentImageModel.defaultProps = { isOpen: false };

export default ContentImageModel;
